// extracted by mini-css-extract-plugin
export var aboveInput = "_jp-0";
export var actionButton = "_jp-5";
export var actionButtonContainer = "_jp-1";
export var actionIcon = "_jp-6";
export var aiInfoContainer = "_jp-2";
export var attachmentWrapper = "_jp-7";
export var bold = "_jp-3";
export var checkIcon = "_jp-8";
export var clickingRecipientBar = "_jp-11";
export var commentThreadSwitch = "_jp-a";
export var draftImage = "_jp-b";
export var draftImageContainer = "_jp-c";
export var draftImages = "_jp-e";
export var editButton = "_jp-g";
export var editor = "_jp-f";
export var editorContainer = "_jp-y";
export var editorErrorTooltipWrapper = "_jp-9";
export var headerDivider = "_jp-h";
export var icon = "_jp-i";
export var info = "_jp-j";
export var internal = "_jp-n";
export var internalDivider = "_jp-k";
export var internalMessage = "_jp-l";
export var messageInputCard = "_jp-m";
export var messageInputForm = "_jp-o";
export var messageInputFormInternal = "_jp-p";
export var options = "_jp-q";
export var publicMessageCustomer = "_jp-s";
export var publicMessageMerchant = "_jp-r";
export var removeImageButton = "_jp-d";
export var replyButtons = "_jp-t";
export var showSignatureButton = "_jp-u";
export var spinner = "_jp-v";
export var verticalButtonDivider = "_jp-4";
export var visibilitySelector = "_jp-w";
export var warning = "_jp-x";
export var wrappingText = "_jp-z";
export var writingInternalNoteTopBorder = "_jp-10";